import { MpfInputBaseProps, mpfInputDefaults, MpfInputEmits } from '../MpfInput/MpfInputBaseProps';

export interface MpfInputTextareaProps extends MpfInputBaseProps {
  rows?: number;
}

export type MpfTextareaEmits = MpfInputEmits;

export const mpfTextareaDefaults = {
  ...mpfInputDefaults,
  rows: 3,
};
